<div fxLayout="column">
    <h1 matDialogTitle>{{'APP_PLATFORM_CONFIRM_DIALOG.CONFIRM_HEADER'| translate}}</h1>
    <div mat-dialog-content>{{confirmMessage | translate}}</div>
    <div class="pt-24" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button (click)="dialogRef.close(false)">Cancel</button>
        <button mat-raised-button color="primary" (click)="dialogRef.close(true)">Confirm</button>
    </div>
</div>